module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAACXBIWXMAAAsSAAALEgHS3X78AAAAxklEQVRIicXWvQ3CMBCG4dcpUjOGy6yAlAEYIUwGG7CAJUaAMmNQu0KAIgXIj+37EFfZVzyyZfvODOFD3PkQNxij4oV1wAk4W1HnQ2yAyyh3BbZ9W99KwKpv6wdwHOUay0rdMPAhHoDOulI3nihQ95mwol+gFZ0ELegsWIougiXoKpiLJoE5aDKYimaBKWg2uIYWgUtoVQrOxf+3LD0U6bWRXmzp05MWB2n5khZYaQuQNilpG5U2ehX2BH/1WdorsLeQfDiBOyEjvsoP+7XaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/right-carot-large.png
// module id = 1778
// module chunks = 0